/* eslint-disable no-undef */
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  selectAuthenticate,
  hideSmsModal,
  authenticateOtp,
  authenticateVerify
} from "../../../state/ducks/login";
import Countdown from "react-countdown";
import $ from "jquery";
import Modal from "react-modal";
import NumberFormat from "react-number-format";
import Inputmask from "inputmask";
import { Link } from "react-router-dom";
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    transform: "translate(-50%, -50%)",
    border: "none",
    padding: "0",
    background: "none",
  },
};

Modal.setAppElement("#app");

class SmsVerify extends Component {
  state = {
    smsCode: "",
    loginType: 1,
    platform: "web",
    token: "",
  };
  maskAndRegexInput() {

    var smsKodu = document.getElementById("sms_kodu");
    if (smsKodu != null) {

      Inputmask("(999) 999-99-99").mask(smsKodu);
    }

  }
  componentDidMount() {
    this.maskAndRegexInput()
    this.createCaptchaToken();
  }

  hideModal = () => {
    this.props.hideSmsModal();
  };

  timerEnd() {
    $("#sms_kodu").prop("disabled", true);
    $("#submit").css("pointer-events", "none");
    $("#tekrar_gonder").css("pointer-events", "all");
  }

  timerStart() {
    var time = this.props.login?.countDate + 180000 < Date.now();
    $("#sms_kodu").prop("disabled", time);
    $("#submit").prop("disabled", time);
    if (time) {
      $("#tekrar_gonder").css("pointer-events", "all");
    } else {
      $("#tekrar_gonder").css("pointer-events", "none");
    }
  }

  reSendSmsCode = (verifyType) => {
   
    const postData = {
      username: this.props.login.username,
      password: this.props.login.password,
      platform: this.state.platform,
      token: this.state.token,
      verifyType: verifyType,
    };
    this.props.authenticateOtp(postData);
    this.setState({
      userName: "",
      password: "",
    });
    this.createCaptchaToken();

    $("#submit").css("pointer-events", "all");
  };



  authenticateVerify = (event) => {
    event.preventDefault();
    const postData = {
      username: this.props.login.username,
      password: this.props.login.password,
      smsCode: this.state.smsCode,
      platform: this.state.platform,
      token: this.state.token,
    };
    this.props.authenticateVerify(postData);
    this.setState({
      smsCode: "",
    });
    this.createCaptchaToken();
  };

  createCaptchaToken() {
    var that = this;
    grecaptcha.ready(function () {
      grecaptcha
        .execute("6LeiYdwUAAAAAFsmN76CLhs9VADdnPT4OnzKWCFT", {
          action: "/Home",
        })
        .then((token) => {
          that.setState({ token: token });
        });
    });
  }


  authenticateOtp = (event) => {
    event.preventDefault();
    const { login } = this.props;
    const postData = {
      username: login.username,
      password: login.password,
      platform: this.state.platform,
      token: this.state.token,
      verifyType: 2,
    };
    this.props.authenticateOtp(postData);
    this.setState({
      userName: "",
      password: "",
    });
    this.createCaptchaToken();
  };



  render() {

    const { login } = this.props;
    return (
      <div>
        <Modal
          isOpen={login.controlSmsVerify}
          onRequestClose={this.closeModal}
          style={{
            overlay: {
              backgroundColor: "rgba(0, 0, 0, 0.70)"

            },
            content: {
              top: "50%",
              left: "50%",
              right: "auto",
              bottom: "auto",
              transform: "translate(-50%, -50%)",
              border: "none",
              padding: "0",
              background: "none",
              width: "100%"
            }
          }}
        >

          <div
            className="container-fluid"
            role="document"
            style={{ boxSizing: "unset" }}
          >

            <div className="row d-flex align-items-center justify-content-center vh-100">
              <div
                className="col-10 col-md-7 col-lg-6 col-xl-5 t-sifreAlaniPopup"

              >

                <div className="row no-gutters px-4">
                  <div className="col-12 pr-4 d-flex justify-content-end " >
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                      onClick={() => this.hideModal()}
                    >
                      <span aria-hidden="true" className="text-white">
                        &times;
                      </span>
                    </button>
                  </div>

                </div>
                <div className="row no-gutters d-flex justify-content-center px-4">
                  {/* LOGO */}
                  <div className="col-12 d-flex justify-content-center pb-2">
                    <i className="t-icon-lock_clock t-loginSifreAlBaslikIcon" />
                  </div>
                  <div className="col-12 d-flex justify-content-center pb-3 t-loginSifreAlBaslik">
                    SMS DOĞRULAMA
                  </div>
                  <div
                    className="col-12 col-lg-8 pb-2 text-center"
                    style={{ color: "#95C11F" }}
                  >
                    <p>
                      {login?.response}
                    </p>
                  </div>
                  {/* TC Kimlik */}
                  <div className="col-12 col-lg-10 col-xl-8 pb-2">
                    <span className="t-loginText pl-3">SMS Şifreniz</span>
                  </div>
                  <div className="col-12 col-lg-10 col-xl-8">
                    <div className="t-inputLogin">
                      <div>
                        <i className="t-icon-phonelink_lock" />
                      </div>
                      <NumberFormat
                        displayType={"input"}
                        maxLength="6"
                        minLength="6"
                        id="sms_kodu"
                        name="sms_kodu"
                        className="smsdecimalnumber"
                        placeholder="SMS Şifrenizi giriniz"
                        value={this.state.smsCode}
                        onChange={(e) => {
                          this.setState({ smsCode: e.target.value });
                        }}
                        required={true}
                        autoComplete="new-password"
                      />
                      <div />
                    </div>
                  </div>
                  <div
                    className="col-12 col-lg-8 py-4 text-center"
                    style={{ color: "#F39200", fontWeight: "bold" }}
                  >
                    <i className="t-icon-clock" />
                    <Countdown
                      key={login?.countDate}
                      date={login?.countDate + 180000}
                      renderer={(props) => (
                        <strong id="count_down"> {props.total / 1000}</strong>
                      )}
                      onStart={() => this.timerStart()}
                      onComplete={() => this.timerEnd()}
                    ></Countdown>
                  </div>
                  {/* Geri Sayım JS si*/}
                  {/* Geri Sayım JS si BİTTİ*/}
                  {/* ara boşluk*/}
                  <div className="col-12" />
                  {/* GİRİŞ ve GERİ DON */}
                  <div className="col-auto pt-4 px-1">
                    <a
                      href="#tekrar"
                      target="_parent"
                      id="tekrar_gonder"
                      name="tekrar_gonder"

                    onClick={() => this.reSendSmsCode(1)}

                      className="t-loginGeridonButton"
                    >
                      <i className="t-icon-loop2 px-2" style={{ fontSize: "14pt" }} />
                      TEKRAR GÖNDER
                      <span className="pr-2" />
                    </a>
                  </div>
                  <div className="col-auto pt-4 px-1">
                    <button
                      className="t-loginGirisButton"
                      id="submit"
                      type="submit"

                      onClick={this.authenticateVerify}
                    // style={
                    //   login.success
                    //     ? { display: "none" }
                    //     : { display: "inline-block" }
                    // }
                    >
                      <span className="px-2" />
                      GİRİŞ
                      <i
                        className="t-icon-arrow-right2 pl-2"
                        style={{ fontSize: "14pt" }}
                      />
                    </button>

                  </div>

                </div>

                <div className=" justify-content-center text-center mt-5">
                  <Link
                    to={{}}
                    onClick={this.authenticateOtp}
                  >

                    <small className="t-loginLink">
                      <span  style={{ fontSize: "13pt", color: "#f39200" }}>Doğrulama kodunu alamadınız mı?</span> <span style={{ fontSize: "13pt", color: "#8eb721" }}>Eposta ile doğrulayın.</span>
                    </small>
                  </Link>
                </div>
              </div>
            </div>
          </div>


        </Modal>

        <Modal
          isOpen={login.controlEpostaVerify}
          onRequestClose={this.closeModal}
          style={{
            overlay: {
              backgroundColor: "rgba(0, 0, 0, 0.70)"

            },
            content: {
              top: "50%",
              left: "50%",
              right: "auto",
              bottom: "auto",
              transform: "translate(-50%, -50%)",
              border: "none",
              padding: "0",
              background: "none",
              width: "100%"
            }
          }}
        >

          <div
            className="container-fluid"
            role="document"
            style={{ boxSizing: "unset" }}
          >

            <div className="row d-flex align-items-center justify-content-center vh-100">
              <div
                className="col-10 col-md-7 col-lg-6 col-xl-5 t-sifreAlaniPopup"

              >

                <div className="row no-gutters px-4">
                  <div className="col-12 pr-4 d-flex justify-content-end " >
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                      onClick={() => this.hideModal()}
                    >
                      <span aria-hidden="true" className="text-white">
                        &times;
                      </span>
                    </button>
                  </div>

                </div>
                <div className="row no-gutters d-flex justify-content-center px-4">
                  {/* LOGO */}
                  <div className="col-12 d-flex justify-content-center pb-2">
                    <i className="t-icon-lock_clock t-loginSifreAlBaslikIcon" />
                  </div>
                  <div className="col-12 d-flex justify-content-center pb-3 t-loginSifreAlBaslik">
                    EPOSTA DOĞRULAMA
                  </div>
                  <div
                    className="col-12 col-lg-8 pb-2 text-center"
                    style={{ color: "#95C11F" }}
                  >
                    <p>
                      {login?.response}
                    </p>
                  </div>
                  {/* TC Kimlik */}
                  <div className="col-12 col-lg-10 col-xl-8 pb-2">
                    <span className="t-loginText pl-3">Eposta Doğrulama Kodu</span>
                  </div>
                  <div className="col-12 col-lg-10 col-xl-8">
                    <div className="t-inputLogin">
                      <div>
                        <i className="t-icon-phonelink_lock" />
                      </div>
                      <NumberFormat
                        displayType={"input"}
                        maxLength="6"
                        minLength="6"
                        id="sms_kodu"
                        name="sms_kodu"
                        className="smsdecimalnumber"
                        placeholder="Eposta doğrulama kodunu giriniz"
                        value={this.state.smsCode}
                        onChange={(e) => {
                          this.setState({ smsCode: e.target.value });
                        }}
                        required={true}
                        autoComplete="new-password"
                      />
                      <div />
                    </div>
                  </div>
                  <div
                    className="col-12 col-lg-8 py-4 text-center"
                    style={{ color: "#F39200", fontWeight: "bold" }}
                  >
                    <i className="t-icon-clock" />
                    <Countdown
                      key={login?.countDate}
                      date={login?.countDate + 180000}
                      renderer={(props) => (
                        <strong id="count_down"> {props.total / 1000}</strong>
                      )}
                      onStart={() => this.timerStart()}
                      onComplete={() => this.timerEnd()}
                    ></Countdown>
                  </div>
                  {/* Geri Sayım JS si*/}
                  {/* Geri Sayım JS si BİTTİ*/}
                  {/* ara boşluk*/}
                  <div className="col-12" />
                  {/* GİRİŞ ve GERİ DON */}
                  <div className="col-auto pt-4 px-1">
                    <a
                      href="#tekrar"
                      target="_parent"
                      id="tekrar_gonder"
                      name="tekrar_gonder"

                       
                    onClick={() => this.reSendSmsCode(2)}

                      className="t-loginGeridonButton"
                    >
                      <i className="t-icon-loop2 px-2" style={{ fontSize: "14pt" }} />
                      TEKRAR GÖNDER
                      <span className="pr-2" />
                    </a>
                  </div>
                  <div className="col-auto pt-4 px-1">
                    <button
                      className="t-loginGirisButton"
                      id="submit"
                      type="submit"

                      onClick={this.authenticateVerify}
                    // style={
                    //   login.success
                    //     ? { display: "none" }
                    //     : { display: "inline-block" }
                    // }
                    >
                      <span className="px-2" />
                      GİRİŞ
                      <i
                        className="t-icon-arrow-right2 pl-2"
                        style={{ fontSize: "14pt" }}
                      />
                    </button>

                  </div>

                </div>

                {/* <div className=" justify-content-center text-center mt-5">
                    <Link
                    
                    onClick={this.showSmsVerify}
                  >
                    <small className="t-loginLink">
                      Doğrulama kodunu alamadınız mı? Sms ile doğrulayın.
                    </small>
                  </Link>
                </div> */}
              </div>
            </div>
          </div>


        </Modal>

      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    login: selectAuthenticate(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  authenticateOtp: (postData) => dispatch(authenticateOtp(postData)),
  authenticateVerify: (postData) => dispatch(authenticateVerify(postData)),
  hideSmsModal: () => dispatch(hideSmsModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SmsVerify);
